export function PersonSVG() {
  return (
    <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99998 10C11.8416 10 13.3333 8.50834 13.3333 6.66668C13.3333 4.82501 11.8416 3.33334 9.99998 3.33334C8.15831 3.33334 6.66665 4.82501 6.66665 6.66668C6.66665 8.50834 8.15831 10 9.99998 10ZM9.99998 11.6667C7.77498 11.6667 3.33331 12.7833 3.33331 15V16.6667H16.6666V15C16.6666 12.7833 12.225 11.6667 9.99998 11.6667Z"
        fill="#D7D8E2"
      />
    </svg>
  );
}

export default PersonSVG;
